import React, { Component } from 'react';
import ButtonLink from '../common/TrackedButtonLink';
import ProductImageCTA from '../common/ProductImageCTA';
import Testimonial from '../category/common/Testimonial';
import Feature from '../common/Feature';
import { Link } from 'react-scroll';
import Hero from '../category/common/Hero';
import Sticky from 'react-sticky-el';
import Header from '../common/Header';

class StyleGuide extends Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
			selected: null,
			readMore: false,
			readMore1: false,
			readMore2: false
		};
	}
	handleClickReadMore() {
		if (this.state.readMore === false) {
			this.setState({ readMore: true });
		} else {
			this.setState({ readMore: false });
		}
	}
	handleClickReadMore1() {
		if (this.state.readMore1 === false) {
			this.setState({ readMore1: true });
		} else {
			this.setState({ readMore1: false });
		}
	}
	handleClickReadMore2() {
		if (this.state.readMore2 === false) {
			this.setState({ readMore2: true });
		} else {
			this.setState({ readMore2: false });
		}
	}

	handleStickyClick(e) {

	}

	render() {

		const productImageCta = [1, 2, 3].map((product, index) => (
			<ProductImageCTA
				key={index}
				imgSrc="http://fpoimg.com/190x190?text=FPO"
				title="Safe Name"
				modelNumber="XXX-XXX"
			/>
		));

		return (
			<div className="styleguide">

				<h3>Hero Image</h3>
				<Hero
					imageSrc={"http://fpoimg.com/1366x480?text=FPO"}
					imageAlt="ALT"
					title={"Page Title"}
					description="Page description text."
				/>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Page Header</h3>
				<Header
					title="Page Title"
					description="Page Description."
				/>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Page Sticky Sub-Navigation</h3>

				<Sticky className="page-nav">
					<div className="row">
						<div className="col">
							<ul>
								<li>
									<Link
										to="/styleguide"
										onClick={e => this.handleStickyClick(e)}
									>
										Sub-Title
									</Link>
								</li>
								<li>
									<Link
										to="/styleguide"
										onClick={e => this.handleStickyClick(e)}
									>
										Sub-Title
									</Link>
								</li>
								<li>
									<Link
										to="/styleguide"
										onClick={e => this.handleStickyClick(e)}
									>
										Sub-Title
									</Link>
								</li>
								<li>
									<Link
										to="/styleguide"
										onClick={e => this.handleStickyClick(e)}
									>
										Sub-Title
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</Sticky>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Safe Callout</h3>
				<section className="row safes-callout">
					<div className="col sm-3 callout-descr">
						<h2 className="section-title">Title</h2>
						<p>Description</p>
						<ButtonLink className="btn-primary" to="/styleguide">Button Text</ButtonLink>
					</div>
					<div className="col sm-9 products">
						<ul> {productImageCta}</ul>
					</div>
				</section>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />

				<h3>Product Feature</h3>
				<div className="product-feature">
					<div className="feature-image">
						<img src="http://fpoimg.com/600x300?text=FPO" alt="" />
					</div>
					<div className="feature-content">
						<h2 className="feature-title feature-title--large">Feature Title</h2>
						<p>Feature Description</p>
						<ButtonLink className="btn-primary" to="/styleguide">Button Text</ButtonLink>
					</div>
				</div>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />

				<h3>Feature Callout</h3>
				<section className="row feature-callout callout-alt">
					<div className="col sm-5 sm-hide">
						<img src="http://fpoimg.com/569x429?text=FPO" />
					</div>
					<div className="col sm-7 content">
						<div>
							<img
								className="icon"
								src="http://fpoimg.com/94x94?text=Icon"
							/>
							<img
								className="icon"
								src="http://fpoimg.com/94x94?text=Icon"
							/>
							<h3>Callout Title</h3>
							<p>Callout Description</p>
							<ButtonLink className="btn-primary" to="/styleguide">Button Text</ButtonLink>
						</div>
					</div>
				</section>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />

				<h3>Card Container</h3>
				<section className="card-container my-5">
					<div className="card">
						<a href="/styleguide">
							<div><img src="http://fpoimg.com/420x240?text=FPO" /></div>
							<div className="card-body">
								<h2>Card Title</h2>
								<p>Card Detail</p>
								<div className="pt-4">
									<span className="btn btn-primary">Button Text</span>
								</div>
							</div>
						</a>
					</div>
					<div className="card">
						<a href="/styleguide">
							<div><img src="http://fpoimg.com/420x240?text=FPO" /></div>
							<div className="card-body">
								<h2>Card Title</h2>
								<p>Card Detail</p>
								<div className="pt-4">
									<span className="btn btn-primary">Button Text</span>
								</div>
							</div>
						</a>
					</div>
					<div className="card">
						<a href="/styleguide">
							<div><img src="http://fpoimg.com/420x240?text=FPO" /></div>
							<div className="card-body">
								<h2>Card Title</h2>
								<p>Card Detail</p>
								<div className="pt-4">
									<span className="btn btn-primary">Button Text</span>
								</div>
							</div>
						</a>
					</div>
				</section>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Testimonial</h3>
				<Testimonial
					imgSrc1={"http://fpoimg.com/800x800?text=FPO"}
					alt1="Flood"
					quote="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non placerat orci. Morbi auctor justo quam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer porta urna non nunc vehicula, eu pharetra lorem ultricies. Nam ipsum augue, viverra vitae nisi sit amet, lacinia hendrerit erat. In tristique ligula velit. Vestibulum varius gravida nulla, non luctus massa cursus in. Nulla facilisi."
					submitted="Client N."
					readLink="Link Text"
					link="/styleguide" />


				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Testimonial Quote</h3>
				<div className='customer-stories'>
					<div className="testimonial-quote">
						<p>
							&ldquo;Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non placerat orci. &rdquo;
						</p>
						<p className="submission">Submitted by Client N.</p>
					</div>
				</div>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Text Cards</h3>

				<section className="row testimonial-cards">
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Title</h3>
								<p className="category h4">
									<Link to="/styleguide">Link Text</Link>
								</p>
								<p className="submission h4">Submitted by Client N.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore ? 'active' : ''}`}>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non placerat orci. Morbi auctor justo quam. Lorem ipsum dolor sit
									<span className="read-more-content">
										&nbsp;amet, consectetur adipiscing elit. Integer porta urna non nunc vehicula, eu pharetra lorem ultricies. Nam ipsum augue, viverra vitae nisi sit amet, lacinia hendrerit erat. In tristique ligula velit. Vestibulum varius gravida nulla, non luctus massa cursus in.
										<span className="cat-callout">
											<Link to="/styleguide">Link Text.</Link>
										</span>
									</span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore.bind(this)}
								>
									{this.state.readMore ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Title</h3>
								<p className="category h4">
									<Link to="/styleguide">Link Text</Link>
								</p>
								<p className="submission h4">Submitted by Client N.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore1 ? 'active' : ''}`}>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non placerat orci. Morbi auctor justo quam. Lorem ipsum dolor sit
									<span className="read-more-content">
										&nbsp;amet, consectetur adipiscing elit. Integer porta urna non nunc vehicula, eu pharetra lorem ultricies. Nam ipsum augue, viverra vitae nisi sit amet, lacinia hendrerit erat. In tristique ligula velit. Vestibulum varius gravida nulla, non luctus massa cursus in.
										<span className="cat-callout">
											<Link to="/styleguide">Link Text.</Link>
										</span>
									</span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore1.bind(this)}
								>
									{this.state.readMore1 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore1 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Title</h3>
								<p className="category h4">
									<Link to="/styleguide">Link Text</Link>
								</p>
								<p className="submission h4">Submitted by Client N.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore2 ? 'active' : ''}`}>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non placerat orci. Morbi auctor justo quam. Lorem ipsum dolor sit
									<span className="read-more-content">
										&nbsp;amet, consectetur adipiscing elit. Integer porta urna non nunc vehicula, eu pharetra lorem ultricies. Nam ipsum augue, viverra vitae nisi sit amet, lacinia hendrerit erat. In tristique ligula velit. Vestibulum varius gravida nulla, non luctus massa cursus in.
										<span className="cat-callout">
											<Link to="/styleguide">Link Text.</Link>
										</span>
									</span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore2.bind(this)}
								>
									{this.state.readMore2 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore2 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
				</section>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Features</h3>

				<section className="row features">
					<div className="col">
						<h2 className="title">Headline</h2>
					</div>
					<div className="callouts">
						<Feature
							key="feature-1"
							title="Title"
							description="Description Text"
							image={"http://fpoimg.com/107x107?text=FPO"}
						/>
						<Feature
							key="feature-2"
							title="Title"
							description="Description Text"
							image={"http://fpoimg.com/107x107?text=FPO"}
						/>
						<Feature
							key="feature-3"
							title="Title"
							description="Description Text"
							image={"http://fpoimg.com/107x107?text=FPO"}
						/>
						<Feature
							key="feature-4"
							title="Title"
							description="Description Text"
							image={"http://fpoimg.com/107x107?text=FPO"}
						/>
						<Feature
							key="feature-5"
							title="Title"
							description="Description Text"
							image={"http://fpoimg.com/107x107?text=FPO"}
						/>
						<Feature
							key="feature-6"
							title="Title"
							description="Description Text"
							image={"http://fpoimg.com/107x107?text=FPO"}
						/>
					</div>
				</section>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />
				<h3>Dark Callout</h3>

				<section className="row callout-dark">
					<div className="col sm-6 left">
						<h3 className="h4">Title</h3>
						<img
							className="icon"
							src={"http://fpoimg.com/45x45?text=Icon"}
							alt="Contact Us"
						/>
						<p>Description Text</p>
						<Link
							to="/styleguild"
							className="arrow-link"
						>
							Link Text
						</Link>
					</div>
					<div className="col sm-6 right">
						<h3 className="h4">Title</h3>
						<img
							className="icon"
							src={"http://fpoimg.com/45x45?text=Icon"}
							alt="Contact Us"
						/>
						<p>Description Text</p>
						<Link
							to="/styleguild"
							className="arrow-link"
						>
							Link Text
						</Link>
					</div>
				</section>

				<hr style={{ marginBottom: '50px', marginTop: '50px' }} />

			</div >
		);
	}
};

export default StyleGuide;


// WEBPACK FOOTER //
// ./src/pages/styleguide/Index.js